import React from "react";
import { MessageCircle, Send } from "lucide-react";
import { BRAND, waLink } from "../mock";

export default function FloatingButtons() {
  return (
    <div className="fixed right-4 bottom-6 z-50 flex flex-col gap-3">
      <a href={BRAND.telegram} target="_blank" rel="noreferrer" aria-label="Telegram"
        className="w-12 h-12 grid place-items-center rounded-full text-white shadow-lg transition-transform hover:scale-110"
        style={{ background: "linear-gradient(135deg,#2e9bff,#1877e6)", boxShadow: "0 8px 24px rgba(46,155,255,0.5)" }}>
        <Send className="w-5 h-5" />
      </a>
      <a href={waLink("Hi, I'm interested in THE REAL ALGO EA")} target="_blank" rel="noreferrer" aria-label="WhatsApp"
        className="w-12 h-12 grid place-items-center rounded-full text-white shadow-lg transition-transform hover:scale-110"
        style={{ background: "linear-gradient(135deg,#25d366,#12a150)", boxShadow: "0 8px 24px rgba(37,211,102,0.5)" }}>
        <MessageCircle className="w-5 h-5" />
      </a>
    </div>
  );
}
